import {useQuery} from "@tanstack/react-query";
import {getOfferTemplateQueryOptions} from "./get-offer-template.query-options";

export function useGetOfferTemplate(id: string) {
  return useQuery(getOfferTemplateQueryOptions(id));
}
